import { useQuery } from '@tanstack/react-query'

import { cartService } from './production-carts-service'

export const useProductionCarts = (params: { flow_id?: string | null } = {}) => {
  return useQuery({
    queryKey: ['production-carts', params.flow_id],
    queryFn: () => cartService.get(params)
  })
}
